import React, { useMemo } from 'react'
import { Box, Typography, Button, useMediaQuery } from '@material-ui/core'
import { CheckIcon } from '~/assets/icons'
import { LetterWithSmile } from '~/assets/illustrations'
import { mutualTheme } from '~/utils/theme'
import { MODAL_TYPE } from '../..'

export type SuccessValidationModalProps = {
  isEmail?: boolean,
  toggleModal: () => void,
  setOpenedModalType: (modalType: MODAL_TYPE) => void
}

export const SuccessValidationModal: React.FC<SuccessValidationModalProps> = (props) => {
  const { toggleModal, isEmail } = props
  const matches = useMediaQuery(mutualTheme.breakpoints.down('md'))
  const illustrationSize = useMemo(() => matches ? 120 : 200, [matches])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center' }}>
      <LetterWithSmile width={illustrationSize} height={illustrationSize} />
      <Typography sx={{ fontWeight: 'fontWeightBold' }} variant={matches ? 'airbnbH4' : 'airbnbH3'} marginTop={4}>
        {`Validação de ${isEmail ? 'e-mail' : 'telefone'} concluída`}
      </Typography>
      <Typography variant={matches ? 'airbnbBody2' : 'airbnbBody1'}>
        {`Seu ${isEmail ? 'e-mail' : 'telefone'} foi validado com sucesso!`}
      </Typography>
      <Button
        variant='contained'
        color='primary'
        size='large'
        onClick={toggleModal}
        startIcon={<CheckIcon htmlColor={mutualTheme.palette.common.white} />}
        sx={{
          marginTop: 3,
          height: 56,
          fontFamily: 'Airbnb',
          fontWeight: 'fontWeightBold'
        }}
      >
        Ok, entendi
      </Button>
    </Box>
  )
}
